// extracted by mini-css-extract-plugin
module.exports = {"title":"style_title__BzZjK","subtitle":"style_subtitle__3yfQ3"};